import { createElement } from '../../../core/dom/helpers.js';

/** @type {import('../../../contracts/filters.js').FilterDriver} */
export const datetimeFilterDriver = {
  type: 'datetime',
  mount(container, ctx) {
    const { def, onChange } = ctx;

    const input = /** @type {HTMLInputElement} */ (createElement('input', {
      type: 'datetime-local',
      id: `filter-${def.key}`,
      name: def.key,
    }));
    if (typeof ctx.value === 'string') {
      input.value = ctx.value;
    }
    if (def.placeholder) {
      input.setAttribute('placeholder', def.placeholder);
    }

    input.addEventListener('change', () => onChange(input.value));
    container.appendChild(input);

    return {
      setValue(value) {
        input.value = typeof value === 'string' ? value : '';
      },
      getValue() {
        return input.value;
      },
      destroy() {
        input.remove();
      },
    };
  },
};
